import api from './api';

export const sprintService = {
  getAll: async (params = {}) => {
    const response = await api.get('/sprints', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/sprints/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/sprints', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/sprints/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/sprints/${id}`);
    return response.data;
  },

  start: async (id) => {
    const response = await api.post(`/sprints/${id}/start`);
    return response.data;
  },

  complete: async (id, moveUnfinishedTo = 'backlog') => {
    const response = await api.post(`/sprints/${id}/complete`, { moveUnfinishedTo });
    return response.data;
  },

  getTasks: async (sprintId) => {
    const response = await api.get(`/sprints/${sprintId}/tasks`);
    return response.data;
  },

  addTask: async (sprintId, taskId) => {
    const response = await api.post(`/sprints/${sprintId}/tasks`, { taskId });
    return response.data;
  },

  removeTask: async (sprintId, taskId) => {
    const response = await api.delete(`/sprints/${sprintId}/tasks/${taskId}`);
    return response.data;
  },
};

export default sprintService;
